import { render, staticRenderFns } from "./XcqManuscriptFooter.vue?vue&type=template&id=5a1d771e&scoped=true&"
import script from "./XcqManuscriptFooter.vue?vue&type=script&lang=ts&"
export * from "./XcqManuscriptFooter.vue?vue&type=script&lang=ts&"
import style0 from "./XcqManuscriptFooter.vue?vue&type=style&index=0&id=5a1d771e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1d771e",
  null
  
)

export default component.exports